module.exports = __webpack_public_path__ + "img/Irons.dffa6a94.png";